// extracted by mini-css-extract-plugin
export default {"root":"BuyNowButton_root__e4CqP","button":"BuyNowButton_button__GwPtf","helper":"BuyNowButton_helper__8sBXw textBodyXs"};